import { memo } from 'react';
import '../styles/a1_monitor.scss';
import { FullscreenButton } from './fullscreenButton';
import WaitingScreen from './waiting_screen';
import { useSocketConnection } from '../hooks/useSocketConnection';
import { Outlet } from 'react-router-dom';
import { CopyRight } from '../components/copyRight';

function A1MonitorLayout() {
	const { status } = useSocketConnection();

	return (
		<div className='fixed right-0 flex h-screen w-screen overflow-hidden'>
			{status === 'CONNECTED' ? (
				<Outlet />
			) : (
				<WaitingScreen waitingText='waiting for connection...' />
			)}
			<CopyRight />
			<FullscreenButton />
		</div>
	);
}

export default memo(A1MonitorLayout);
